import { getSchemeColor } from '@griply/utils';
import { DefaultTheme } from 'styled-components';

import { ColorScheme } from './theme/color-schemes';

export const schemeColor = <T extends string | null | undefined>(
  color: T,
  theme: DefaultTheme,
): T => getSchemeColor(color, theme.colorScheme === ColorScheme.Dark);
